import { render, staticRenderFns } from "./MspForsageMenu.vue?vue&type=template&id=5669d960&"
import script from "./MspForsageMenu.vue?vue&type=script&lang=js&"
export * from "./MspForsageMenu.vue?vue&type=script&lang=js&"
import style0 from "./MspForsageMenu.vue?vue&type=style&index=0&id=5669d960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports